import {debounce} from 'lodash'
import {NumberHelper} from '~/helpers/numberHelper'
import DOMPurify from 'dompurify'

const dropdownAsideParams = {
  type: 'aside',
  attributes: [
    { name: 'id', value: 'root-dropdown' },
    { name: 'class', value: 'dropdown show' },
  ]
};

let $initialParent, asideParent, $currentDropdown, lastSelection, currentTarget = null;

export function createNode(obj) {
  const type = obj.type || 'div';
  const parent = obj.parent || document.body;
  const node = document.createElement(type);

  const hasText = obj.text !== undefined;
  if (hasText) {
    if (obj.html) {
      node.innerHTML = DOMPurify.sanitize(obj.text)
    } else {
      node.appendChild(document.createTextNode(obj.text));
    }
  }

  const hasAttributes = obj.attributes !== '';
  if (hasAttributes) {
    for (const currentAttribute in obj.attributes) {
      const attr = document.createAttribute(obj.attributes[currentAttribute].name);
      attr.value = obj.attributes[currentAttribute].value;
      node.setAttributeNode(attr);
    }
  }

  parent.appendChild(node);
  return node;
}

export const setPosition = (event, node, leftAdjustment = 0, topAdjustment = 0, position = 'fixed') => {
  const isFixed = position === 'fixed';
  const isRelative = position === 'relative';
  const isAbsolute = position === 'absolute';

  // window values
  const winHeight = window.innerHeight;
  const winWidth = window.innerWidth;
  const scrollTop = isAbsolute || isFixed ? document.documentElement.scrollTop : 0;
  const scrollBottom = scrollTop + winHeight;

  // floatingElement container
  const floatingElement = node;
  const floatingElementWidth = floatingElement.offsetWidth;
  const floatingElementHeight = floatingElement.offsetHeight || floatingElement.scrollHeight;

  // hovering element currently target
  const target = event.currentTarget;
  const cursorPosY = event.clientY || target.getBoundingClientRect().top;

  const targetLeft = target.getBoundingClientRect().left + leftAdjustment;
  const targetTop = isRelative ? target.getBoundingClientRect().top + topAdjustment : scrollTop + cursorPosY + topAdjustment;
  const targetWidth = target.offsetWidth;
  const targetHeight = target.offsetHeight;

  const floatingElementBottomCorner = targetTop + targetHeight + floatingElementHeight;
  const floatingElementTopCorner = targetTop + targetHeight;

  // tooltip on top by default unless default placement already defined
  if (floatingElement.id === 'tooltip-container' && !floatingElement.className.match(/left|right|bottom/)) {
    floatingElement.classList.add('top');
  }

  // value for floatingElement left side position for Top/Bottom placements
  const floatingElementOnTopEdgeLeft = targetLeft - floatingElementWidth / 2 + targetWidth / 2;
  const floatingElementOnTopEdgeRight = floatingElementOnTopEdgeLeft + floatingElementWidth;
  // value for floatingElement top side position for Top placement
  const floatingElementOnTopEdgeTop = targetTop - floatingElementHeight - 5;
  // value for floatingElement left side position for Left placement
  const floatingElementOnLeftEdgeLeft = targetLeft - floatingElementWidth;
  // value for floatingElement top side position for Left/Right placement
  const floatingElementOnLeftEdgeTop = targetTop;
  // value for floatingElement left side position for Right placement
  const floatingElementOnRightEdgeLeft = targetLeft + targetWidth;
  // value for floatingElement top side position for Bottom placement
  const floatingElementOnBottomEdgeTop = targetTop + targetHeight + 5;

  let isOnTopEdge, isOnBottomEdge, floatingElementLeft, floatingElementTop;

  if (isFixed) {
    isOnTopEdge = floatingElementTopCorner > scrollTop;
    isOnBottomEdge = floatingElementBottomCorner > scrollBottom;
  } else {
    isOnTopEdge = (floatingElement.classList.contains('top') || floatingElementOnTopEdgeTop < winHeight) &&
      floatingElementOnTopEdgeLeft > 0 && floatingElementOnTopEdgeLeft < winWidth &&
      floatingElementOnTopEdgeRight > 0 && floatingElementOnTopEdgeRight < winWidth;
    isOnBottomEdge = (floatingElement.classList.contains('bottom') || floatingElementBottomCorner < winHeight) &&
      floatingElementOnTopEdgeLeft > 0 && floatingElementOnTopEdgeLeft < winWidth &&
      floatingElementOnTopEdgeRight > 0 && floatingElementOnTopEdgeRight < winWidth;
  }
  const isOnLeftEdge = floatingElement.classList.contains('left') ||
    floatingElementOnTopEdgeLeft > 0 && floatingElementOnTopEdgeLeft < winWidth;
  const isOnRightEdge = floatingElement.classList.contains('right') ||
    floatingElementOnTopEdgeRight > 0 && floatingElementOnTopEdgeRight < winWidth;

  if (isOnTopEdge && !floatingElement.className.match(/left|right|bottom/)) {
    floatingElementLeft = floatingElementOnTopEdgeLeft;
    floatingElementTop = floatingElementOnTopEdgeTop;
    floatingElement.classList.remove(...['left', 'right', 'bottom'])
    if (!floatingElement.classList.contains('top')) {
      floatingElement.classList.add('top');
    }
  } else if (isOnLeftEdge && !floatingElement.className.match(/right|bottom/)) {
    floatingElementLeft = floatingElementOnLeftEdgeLeft;
    floatingElementTop = floatingElementOnLeftEdgeTop;
    floatingElement.classList.remove(...['top', 'right', 'bottom'])
    if (!floatingElement.classList.contains('left')) {
      floatingElement.classList.add('left');
    }
  } else if (isOnRightEdge && !floatingElement.className.match(/bottom/)) {
    floatingElementLeft = floatingElementOnRightEdgeLeft;
    floatingElementTop = floatingElementOnLeftEdgeTop;
    floatingElement.classList.remove(...['top', 'left', 'bottom'])
    if (!floatingElement.classList.contains('right')) {
      floatingElement.classList.add('right');
    }
  } else if (isOnBottomEdge) {
    floatingElementLeft = floatingElementOnTopEdgeLeft;
    floatingElementTop = floatingElementOnBottomEdgeTop;
    floatingElement.classList.remove(...['top', 'left', 'right'])
    if (!floatingElement.classList.contains('bottom')) {
      floatingElement.classList.add('bottom');
    }
  }

  floatingElement.style.top = NumberHelper.clamp(floatingElementTop, 0, winHeight) + 'px';
  floatingElement.style.left = NumberHelper.clamp(floatingElementLeft, 0, winWidth) + 'px';
};

export const teleport = {
  node: function (node, parent) {
    parent.append(node);
  },

  dropdown: function (event, leftAdjustment = 0, topAdjustment = 0) {
    event.stopPropagation();
    teleport.reset();

    let tooltip = $('#tooltip-container')[0];
    if(tooltip){
      tooltip.remove();
    }

    currentTarget = event.target;
    $currentDropdown = $(currentTarget).parent().find('.dropdown-menu');

    let currentDropdown = $currentDropdown[0];
    $initialParent = $currentDropdown.parent();
    asideParent = createNode(dropdownAsideParams);

    teleport.node(currentDropdown, asideParent);
    setPosition(event, asideParent, leftAdjustment, topAdjustment);

    const unBound = debounce(teleport.reset, 250);
    $currentDropdown.on('mouseleave.dropdownMenu', unBound);
    $currentDropdown.on('mouseenter.dropdownMenu', unBound.cancel);

    $currentDropdown
      .find('.dropdown-item')
      .first()
      .trigger('focus');

    $(document).on('click.dropdownMenu', teleport.reset);
    $(document).on('keyup.dropdownMenu', e => {
      if (e.key === "Escape") {
        teleport.reset();
      }
    });

    lastSelection = currentTarget;
  },

  certificateDropdown: function (event) {
    event.stopPropagation();
    teleport.reset();

    let tooltip = $('#tooltip-container')[0];
    if(tooltip){
      tooltip.remove();
    }

    currentTarget = event.target;
    $currentDropdown = $(currentTarget).closest('.certificate-element.draggable').find('.dropdown-menu');
    if (!$currentDropdown.length) {
      $currentDropdown = $(currentTarget).closest('.grid-cell-container').find('.dropdown-menu');
    }
    let currentDropdown = $currentDropdown[0];
    if (!currentDropdown) {
      return
    }
    $initialParent = $currentDropdown.parent();
    asideParent = createNode(dropdownAsideParams);

    teleport.node(currentDropdown, asideParent);

    asideParent.style.left = event.clientX + 'px';
    let isOutsideBottomBorderScreen = event.clientY + currentDropdown.offsetHeight > window.innerHeight;
    asideParent.style.top = isOutsideBottomBorderScreen ? event.clientY - currentDropdown.offsetHeight + 'px' : event.clientY + 'px';

    const unBound = debounce(teleport.reset, 250);
    $currentDropdown.on('mouseleave.dropdownMenu', unBound);
    $currentDropdown.on('mouseenter.dropdownMenu', unBound.cancel);

    $currentDropdown
      .find('.dropdown-item')
      .first()
      .trigger('focus');

    $(document).on('click.dropdownMenu', teleport.reset);
    $(document).on('keyup.dropdownMenu', e => {
      if (e.key === "Escape") {
        teleport.reset();
      }
    });

    lastSelection = currentTarget;
  },

  inputDropdown: function (event, leftAdjustment = 0, topAdjustment = 0) {
    event.stopPropagation();
    teleport.reset();

    let tooltip = $('#tooltip-container')[0];
    if(tooltip){
      tooltip.remove();
    }

    currentTarget = event.target;
    $(currentTarget).addClass('active');
    $currentDropdown = $(currentTarget).parent().find('.dropdown-menu');

    let currentDropdown = $currentDropdown[0];
    $initialParent = $currentDropdown.parent();
    asideParent = createNode(dropdownAsideParams);

    teleport.node(currentDropdown, asideParent);
    setPosition(event, asideParent, leftAdjustment, topAdjustment);

    const unBound = debounce(teleport.reset, 250);
    $currentDropdown.on('mouseleave.dropdownMenu', unBound);
    $currentDropdown.on('mouseenter.dropdownMenu', unBound.cancel);

    $currentDropdown
      .find('.dropdown-item')
      .first()
      .trigger('focus');

    $(document).on('click.dropdownMenu', teleport.reset);
    $(document).on('keyup.dropdownMenu', e => {
      if (e.key === "Escape") {
        teleport.reset();
      }
    });

    lastSelection = currentTarget;
  },

  aselect: ($event) => {
    //the 1st time you click the button inside the aselect, 2nd time the search and the 3rd time it should be valid.
    currentTarget = $event.target;
    let currentID = $(currentTarget).closest('.a-select').attr('id');
    let hasClickSame = lastSelection === currentID;

    let tooltip = $('#tooltip-container')[0];
    if(tooltip){
      tooltip.remove();
    }

    if (!hasClickSame) {
      teleport.reset();

      currentTarget = $event.target;
      let $currentTarget = $(currentTarget);

      let $aSelect = $currentTarget.closest('.a-select');
      $currentDropdown = $aSelect.find('.dropdown-menu');
      let currentDropdown = $currentDropdown[0];
      let dropdownWidth = currentTarget.offsetWidth;

      let parentClasses = $aSelect[0].className;

      $initialParent = $currentDropdown.parent();

      let asideParams = {
        type: 'aside',
        attributes: [
          { name: 'id', value: 't-aselect' },
          { name: 'class', value: 'dropdown ' + parentClasses },
        ]
      };

      asideParent = createNode(asideParams);
      $(asideParent).css({ width: dropdownWidth });
      teleport.node(currentDropdown, asideParent);

      setPosition($event, asideParent, 0, 20);
    }

    lastSelection = currentID;
  },

  reset: function () {
    if (asideParent) {
      lastSelection = null;
      currentTarget = null;
      const movedDropdown = $(asideParent).find('ul.dropdown-menu')[0];

      $initialParent
        .append(movedDropdown)
        .parent()
        .find('.dropdown-toggle.active')
        .removeClass('active');

      asideParent.remove();
      $currentDropdown.off('.dropdownMenu');
      $(document).off('.dropdownMenu');
    }
  }
};